/* eslint-disable react/destructuring-assignment */
import { BLOCKS } from '@contentful/rich-text-types';
import ReactMarkdown from 'react-markdown';

import { Banner, Container, Video } from 'modules/casesdesucesso/Intern/Intern.style';

export function renderOptions(links: any) {
  const assetMap = new Map();
  links.assets.block.forEach(function (asset: any) {
    assetMap.set(asset.sys.id, asset);
  });

  const entryMap = new Map();
  links.entries.block.forEach(function (entry: any) {
    if (entry) {
      entryMap.set(entry.sys.id, entry);
    }
  });

  return {
    renderNode: {
      [BLOCKS.EMBEDDED_ENTRY]: (node: any) => {
        const {
          data: {
            target: {
              sys: { id },
            },
          },
        } = node;

        const { __typename, image, text } = entryMap.get(id);
        if (__typename === 'BannerCase') {
          return (
            <Banner className="section">
              <Container>
                <div className="text">
                  <ReactMarkdown>{text}</ReactMarkdown>
                </div>
                <div className="image">
                  <img
                    className="img"
                    src={image.url}
                    alt={image.title}
                    width={500}
                    height={500}
                    data-lazzy
                  />
                </div>
              </Container>
            </Banner>
          );
        }
        return false;
      },
      [BLOCKS.EMBEDDED_ASSET]: (node: any) => {
        const {
          data: {
            target: {
              sys: { id },
            },
          },
        } = node;

        const { height, title, url, width } = assetMap.get(id);

        return <img src={url} height={height} width={width} alt={title} />;
      },
      [BLOCKS.PARAGRAPH]: (node: any, children: any) => {
        if (
          node.content[0]?.value === '' &&
          node.content[2]?.value === '' &&
          node.content[1].nodeType === 'hyperlink'
        ) {
          if (node.content[1].data.uri.includes('youtube')) {
            return (
              <Video>
                <iframe
                  width="100%"
                  height="100%"
                  src={node.content[1].data.uri}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </Video>
            );
          }
          return (
            <a href={node.content[1].data.uri} className="btn">
              {node.content[1].content[0].value}
            </a>
          );
        }
        return <p>{children}</p>;
        return false;
      },
    },
  };
}
